/* eslint-disable  import/no-unused-modules */
import icon2x from "./claim-your-home-icon-2x.png";
import icon3x from "./claim-your-home-icon-3x.png";
import icon1x from "./claim-your-home-icon.png";

export { icon1x, icon2x, icon3x };
